import type { PlacedFinding } from './placeFindings.ts';

/** Read through, and still under no message: there is nothing to jump to. */
export function isUnplaced(finding: Pick<PlacedFinding, 'read' | 'messageId'>): boolean {
  return finding.read && finding.messageId === null;
}
